
import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../assets/css/student/about/Involved.css";


const GetInvolved = () => {
  return (
    <div className="inv-get-involved-section">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} lg={10} xl={8}>
            <div className="inv-get-involved-content text-center">
              <h5 className="inv-get-involved-subtitle">
                Get involved
              </h5>

              <h2 className="inv-get-involved-title">
                Join thousands of others
                <br />
                across the country
              </h2>

              <p className="inv-get-involved-text">
                Giving your time means helping to give those most
                <br className="d-none d-lg-block" />
                vulnerable a chance at the future they deserve.
              </p>

              <Button className="inv-cta-button animated-button">
                Make a donation
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default GetInvolved;